// extracted by mini-css-extract-plugin
export default {"layoutFaq":"LayoutFaq_layoutFaq__Ya+2E"};